import { Box, Button } from "@mui/material";
import { memo, useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";

export default memo(function ImageCropper({upImg, uploadFile, cropAreaAspectRation=16/9}) {

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation] = useState(0)
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }, [])


  const uploadPhoto = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        upImg,
        croppedAreaPixels,
        rotation
      )
      uploadFile({src: croppedImage});
    } catch (e) {
      console.error(e)
    }
  }, [croppedAreaPixels, rotation,upImg])

  return (
    <Box sx={{position: 'relative'}}>
      <Box sx={{ minHeight: '75vh', position: 'relative'}}>
        <Cropper
          image={upImg}
          crop={crop}
          // rotation={rotation}
          zoom={zoom}
          aspect={cropAreaAspectRation}
          // cropSize={{width: 1366, height: 768}}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </Box>
      <Button sx={{mt: 3}} variant="contained" onClick={uploadPhoto}> Upload </Button>
    </Box>
  )
});
